const util = {
  S4: function() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  },
  // 产生唯一ID
  guid: function() {
    return (util.S4() + util.S4() + '-' + util.S4() + '-' + util.S4() + '-' + util.S4() + '-' + util.S4() + util.S4() + util.S4());
  },
  checkTel(tel) {
    const mobile = /^1[3|5|8]\d{9}$/;
    const phone = /^0\d{2,3}-?\d{7,8}$/;
    return mobile.test(tel) || phone.test(tel);
  },
  replaceAll(src, f, e) {
    const reg = new RegExp(f, 'g'); // 创建正则RegExp对象
    return src.replace(reg, e);
  }
};

export default util;
